import React from 'react';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import EndDateTimePicker from 'Routes/ListManagement/components/EndDateTimePicker';
import StartDateTimePicker from 'Routes/ListManagement/components/StartDateTimePicker';
import { MerchantField, Comment, PCIInput } from './FormFields';

type Props = {
    merchantSpecific: boolean;
    error: any;
    formikProps: FormikProps<any>;
};

const PanForm = ({ merchantSpecific, error, formikProps }: Props) => {
    const { t } = useTranslation();
    const valueError = error?.data?.error?.param === 'value' && error?.data?.statusCode === 409;

    return (
        <div>
            {merchantSpecific && <MerchantField formikProps={formikProps} error={error} />}
            <PCIInput
                label={t('PAN')}
                formikProps={formikProps}
                errorMsg={valueError ? t('addListEntry.panValidationUnique') : ''}
            />
            <StartDateTimePicker formikProps={formikProps} />
            <EndDateTimePicker formikProps={formikProps} />

            <Comment formikProps={formikProps} error={error} />
        </div>
    );
};

export default React.memo(PanForm);
